import filters from "../data/filter";

export function getFilterName(id) {
  const filterName = filters.filter(function (value, index, arr) {
    return parseInt(value.id, 10) === id;
  });

  return filterName[0] && filterName[0].title;
}
